export default __webpack_public_path__ + "static/media/upload_file_black_24dp.c2e01ca3.svg";